import * as v3 from './v3/task';
import * as v5 from './v5/task';

const impl = process.env.NODE_CONFIG?.backend?.version === 'v5' ? v5 : v3;

export const { parseTask, calculateExpiresTask } = impl;
